import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface PCLRommsProps {
  onBack: () => void;
}

export default function PCLRomms({ onBack }: PCLRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Provisions & Contingent Liabilities" />;
}



